import React from "react";

import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";

import "./simpleHeadboard.scss";

const SimpleHeadboard = (props: ReferenciaCabecera) => {
  return (
    <div className="o-simple-headboard">
      <Breadcrumb content={`${props[0].migaDePan}`} />
    </div>
  )
}

export default SimpleHeadboard;